import ListItem from '../ListItem'
import * as Styled from './styled'
import { listItemsData } from './consts'
import { getIsUserFromStaff } from 'utils'
import { useMemo } from 'react'
import QuestionIcon from 'assets/svgr-icons/question-mark.svg'

import { useModal } from '../../../../../prompt-to-video-playground/hooks/use-modal'
import { Modal } from '../../../../../prompt-to-video-playground/modal'

const MoreBlock = () => {
  const isUserFromStaff = useMemo(() => getIsUserFromStaff(), [])
  const { isModalOpen, openModal, closeModal } = useModal()

  return (
    <Styled.MoreBlock>
      <ul>
        {listItemsData.map(listItemData => (
          <ListItem key={listItemData.id} data={listItemData} />
        ))}
        {isUserFromStaff && (
          <>
            <ListItem
              key="open-prompt-to-video-playground"
              data={{
                id: 'open-prompt-to-video-playground',
                icon: QuestionIcon,
                label: 'Open Prompt to Video Playground',
                onClick: openModal
              }}
            />
            <Modal isOpen={isModalOpen} onClose={closeModal} />
          </>
        )}
      </ul>
    </Styled.MoreBlock>
  )
}

export default MoreBlock
